import React from "react";
import styled from "styled-components";
import ArchiveIcon from "@material-ui/icons/Archive";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 3rem 0;
`;

const Content = styled.div`
  text-align: center;
  margin-top: 1rem;
`;
const SvgContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const NoItems = ({
  content = "There is nothing to display",
}: {
  content?: string;
}) => (
  <Container>
    <SvgContainer>
      <ArchiveIcon />
    </SvgContainer>
    <Content>{content}</Content>
  </Container>
);
